import { render, staticRenderFns } from "./SortingInfo.vue?vue&type=template&id=2bac89ea&functional=true&"
import script from "./SortingInfo.vue?vue&type=script&lang=js&"
export * from "./SortingInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports